import React from "react";
import jwt_decode from "jwt-decode";
import { Link } from "react-router-dom";

class MainMenu extends React.Component {
  constructor(props) {
    super(props);
    var i = 0;
    let path = window.location.pathname.split("/")[1];
    if (path === "volunteers") {
      i = 1;
    } else if (path === "albums") {
      i = 2;
    } else if (path === "playlists") {
      i = 3;
    } else if (path === "on-air") {
      i = 4;
    } else if (path === "program") {
      i = 5;
    } else if (path === "psa") {
      i = 6;
    } else if (path === "survey") {
      i = 7;
    } else if (path === "report") {
      i = 8;
    }
    let id_token = window.localStorage.getItem("id_token");
    var decoded = {};
    if (id_token) {
      decoded = jwt_decode(id_token);
    }

    this.state = {
      i: i,
      isAuthenticated: this.isAuthenticated(decoded),
    };
  }

  isAuthenticated(user) {
    if (user && user.preferred_username) {
      return true;
    }
    return false;
  }

  render() {
    if (!this.state.isAuthenticated) {
      return <div id="main-menu"></div>;
    }
    return (
      <div id="main-menu">
        <div className="region region-navigation">
          <div
            id="block-system-main-menu"
            className="block block-system block-system-main-menu block-menu first last odd"
          >
            <ul className="menu">
              <li className="menu__item is-collapsed collapsed">
                <Link
                  to="/volunteers"
                  className={"menu__link" + this.state.i === 1 ? " active" : ""}
                  onClick={() => this.setState({ i: 1 })}
                >
                  Volunteers
                </Link>
              </li>
              <li className="menu__item is-collapsed collapsed">
                <Link
                  to="/albums"
                  className={"menu__link" + this.state.i === 2 ? " active" : ""}
                  onClick={() => this.setState({ i: 2 })}
                >
                  Albums
                </Link>
              </li>
              <li className="menu__item is-collapsed collapsed">
                <Link
                  to="/playlists"
                  className={"menu__link" + this.state.i === 3 ? " active" : ""}
                  onClick={() => this.setState({ i: 3 })}
                >
                  Playlists
                </Link>
              </li>
              <li className="menu__item is-collapsed collapsed">
                <Link
                  to="/on-air"
                  className={"menu__link" + this.state.i === 4 ? " active" : ""}
                  onClick={() => this.setState({ i: 4 })}
                >
                  On-Air
                </Link>
              </li>
              <li className="menu__item is-collapsed collapsed">
                <Link
                  to="/programs"
                  className={"menu__link" + this.state.i === 5 ? " active" : ""}
                  onClick={() => this.setState({ i: 5 })}
                >
                  Programs
                </Link>
              </li>
              <li className="menu__item is-collapsed collapsed">
                <Link
                  to="/psa"
                  className={"menu__link" + this.state.i === 6 ? " active" : ""}
                  onClick={() => this.setState({ i: 6 })}
                >
                  PSA
                </Link>
              </li>
              <li className="menu__item is-collapsed collapsed">
                <Link
                  to="/survey"
                  className={"menu__link" + this.state.i === 7 ? " active" : ""}
                  onClick={() => this.setState({ i: 7 })}
                >
                  Survey
                </Link>
              </li>
              <li className="menu__item is-collapsed collapsed">
                <Link
                  to="/report"
                  className={"menu__link" + this.state.i === 8 ? " active" : ""}
                  onClick={() => this.setState({ i: 8 })}
                >
                  Report
                </Link>
              </li>
              <li className="menu__item is-collapsed collapsed">
                <a
                  href="https://wwu2.sharepoint.com/:o:/s/VikingUnionTechServices/EpY6_F8l0tpMptUWC6jdQbsBpNlLJhct7FuHVXG_KoAMIg?e=cyqLeA"
                  className="menu__link glyphicon glyphicon-question-sign"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="hidden">Documentation</div>
                </a>
              </li>
              <li className="menu__item is-collapsed collapsed">
                <Link
                  to="/logout"
                  className="menu__link glyphicon glyphicon-log-out"
                >
                  <div className="hidden">Logout</div>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default MainMenu;
